"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _commonReact = require("@devsta/common-react");

var _ConfirmationModal = _interopRequireDefault(require("./ConfirmationModal"));

var _modalNames = _interopRequireDefault(require("../../constants/modalNames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ARE_YOU_SURE_TITLE = 'Are you sure?';

function getApproveModalProps(statusName) {
  switch (statusName) {
    case 'INTERNAL_REVIEW':
      return {
        subtitle: 'By approving this edit, the client can review and comment on the latest edit video.',
        saveBtnText: 'Submit Video'
      };

    case 'APPROVED':
      return {
        subtitle: 'Your video is now complete. Any related video outputs will now be submitted for editing.',
        saveBtnText: 'OK'
      };

    default:
      return {
        subtitle: 'By approving this edit, your video will be set as ‘Completed’ and we’ll start work on any other related outputs & add-on extras.',
        saveBtnText: 'Approve Video'
      };
  }
}

var ModalSwitcher = /*#__PURE__*/function (_Component) {
  _inherits(ModalSwitcher, _Component);

  var _super = _createSuper(ModalSwitcher);

  function ModalSwitcher() {
    var _this;

    _classCallCheck(this, ModalSwitcher);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      var onClose = _this.props.onClose; // Force component rerender without any prop/state change

      _this.setState(function (prevState) {
        return prevState;
      }, onClose);
    });

    _defineProperty(_assertThisInitialized(_this), "getVideoOutputForInvoice", function () {
      var _this$props = _this.props,
          output = _this$props.output,
          versions = _this$props.output.versions;
      return _objectSpread({}, output, {
        versions: versions.slice(-1)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getModalTitle", function () {
      var outputStatus = _this.props.outputStatus;
      return outputStatus.name === 'APPROVED' ? 'Awesome!' : ARE_YOU_SURE_TITLE;
    });

    return _this;
  }

  _createClass(ModalSwitcher, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          openedModal = _this$props2.openedModal,
          outputStatus = _this$props2.outputStatus,
          onRequestChanges = _this$props2.onRequestChanges,
          onApproveVersion = _this$props2.onApproveVersion,
          onClose = _this$props2.onClose,
          videoName = _this$props2.videoName;
      return (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ConfirmationModal.default, _extends({
          title: this.getModalTitle(),
          visible: openedModal === _modalNames.default.APPROVE,
          onClose: onClose,
          onSave: onApproveVersion,
          stayOpenOnSave: true,
          outputStatusName: outputStatus.name
        }, getApproveModalProps(outputStatus.name))), /*#__PURE__*/_react.default.createElement(_ConfirmationModal.default, {
          visible: openedModal === _modalNames.default.APPROVED,
          onClose: onClose,
          onSave: onRequestChanges,
          title: ARE_YOU_SURE_TITLE,
          subtitle: "Are you sure you want to request another version? Your video is already approved and completed",
          saveBtnText: "Continue"
        }), /*#__PURE__*/_react.default.createElement(_commonReact.PaymentsInvoice, {
          stayOpen: true,
          excludeAdditionalOutputCost: true,
          key: "paymentsInvoice-modal-".concat(Date.now()),
          visible: openedModal === _modalNames.default.PAYMENT,
          onConfirm: onRequestChanges,
          onModifyAddons: this.handleClose,
          videoOutputs: [this.getVideoOutputForInvoice()],
          videoName: videoName,
          addonsSelector: "requestedAddons",
          onClose: this.handleClose,
          outputStatus: outputStatus.name
        }))
      );
    }
  }]);

  return ModalSwitcher;
}(_react.Component);

exports.default = ModalSwitcher;